export interface Testimonial {
  name: string;
  role: string;
  avatar: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: '小丸子',
    role: '小红书自拍博主 / 12万粉丝',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20portrait%20of%20young%20Asian%20woman%20with%20natural%20smile%2C%20soft%20lighting%2C%20clean%20minimal%20composition%2C%20professional%20headshot%20style%20with%20gentle%20expression%2C%20cream%20background&width=200&height=200&seq=avatar-testimonial-01&orientation=squarish',
    content: '关注自拍指南半年多了，构图技巧那篇文章彻底改变了我的自拍思路。现在每篇笔记的封面图都被粉丝夸好看，账号涨粉速度明显快了。',
    rating: 5,
  },
  {
    name: '摄影师老张',
    role: '商业人像摄影师 / 8年从业经验',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20man%20in%2030s%20with%20camera%2C%20confident%20expression%2C%20studio%20lighting%2C%20clean%20background%2C%20editorial%20style%20photography&width=200&height=200&seq=avatar-testimonial-02&orientation=squarish',
    content: '作为一名专业摄影师，我很欣赏这个平台对摄影基础知识的重视。布光篇写得比很多付费课程都详细，推荐给所有想认真学好自拍的朋友。',
    rating: 5,
  },
  {
    name: '奶茶小姐',
    role: '大学生 / 自拍爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20college%20student%20portrait%20with%20warm%20smile%2C%20casual%20style%2C%20natural%20lighting%20outdoor%2C%20soft%20bokeh%20background%2C%20friendly%20and%20approachable%20look&width=200&height=200&seq=avatar-testimonial-03&orientation=squarish',
    content: '从完全不懂构图到现在能拍出让朋友追问用什么相机拍的照片，这个网站真的是我的自拍启蒙老师。手机选购那篇帮我省了不少钱！',
    rating: 5,
  },
  {
    name: '科技数码李',
    role: '数码评测博主 / 15万粉丝',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20tech%20reviewer%20portrait%2C%20modern%20clean%20style%2C%20confident%20look%2C%20studio%20portrait%20with%20neutral%20background%2C%20professional%20tech%20industry%20aesthetic&width=200&height=200&seq=avatar-testimonial-04&orientation=squarish',
    content: '手机评测部分数据详实、对比客观，比我看到的很多数码媒体的评测还要专业。每次换手机前都会先来看看这里的推荐。',
    rating: 4,
  },
];

export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export const milestones: Milestone[] = [
  { year: '2023年6月', title: '平台创立', description: '由三位摄影爱好者共同创立，立志打造最专业的国产自拍教学平台' },
  { year: '2023年9月', title: '首篇爆款文章', description: '《自拍构图三分法》发布后48小时内阅读量突破10万，验证了市场对专业自拍教程的强烈需求' },
  { year: '2024年1月', title: '内容体系化', description: '完成六大内容板块搭建，覆盖设备选购到后期修图的全链路自拍教学体系' },
  { year: '2024年6月', title: '百万读者', description: '网站月活跃读者突破100万，成为国内最大、最专业的自拍技巧学习社区' },
  { year: '2024年10月', title: '口碑传播', description: '被多家科技媒体和摄影社区推荐，口碑持续发酵，日均新增读者超过5000人' },
];